export var PriceFormat;
(function (PriceFormat) {
    PriceFormat["decimal"] = "decimal";
    PriceFormat["fraction"] = "fraction";
    PriceFormat["american"] = "american";
})(PriceFormat || (PriceFormat = {}));
export function formatPrice(format, currentPriceNum, currentPriceDen) {
    if (!currentPriceNum || !currentPriceDen) {
        return null;
    }
    if (format === PriceFormat.decimal) {
        const value = (currentPriceNum + currentPriceDen) / currentPriceDen;
        return value.toFixed(2);
    }
    else if (format === PriceFormat.american && currentPriceNum > currentPriceDen) {
        return `+${Math.round((100 * currentPriceNum) / currentPriceDen)}`;
    }
    else if (format === PriceFormat.american) {
        return `-${Math.round(100 / (currentPriceNum / currentPriceDen))}`;
    }
    return `${currentPriceNum}/${currentPriceDen}`;
}
//# sourceMappingURL=formatPrice.js.map